module.exports = __webpack_public_path__ + "static/media/clock.9075e2c7.svg";